import type { components } from '@/api/qraft/schema';

type ProfileType = components['schemas']['ProfileType'];
export type StaffTier = components['schemas']['StaffTier'];

/** Higher outranks lower; `hasTier` compares ranks, never names. */
export const TIER_RANK: Record<StaffTier, number> = {
  FRONT_END_SUPPORT: 0,
  SUPPORT: 1,
  ADMIN: 2,
};

/** What a route that declares no `staticData.minTier` requires: fail closed. */
export const DEFAULT_MIN_TIER: StaffTier = 'ADMIN';

type StaffViewer = {
  profile_type?: ProfileType | null;
  staff_tier?: StaffTier | null;
};

/** Who may enter `/admin/*` at all: any staff tier is an ADMIN profile. */
export function canAccessAdmin(
  me: { profile_type?: ProfileType | null } | undefined,
): boolean {
  return me?.profile_type === 'ADMIN';
}

/**
 * The tier belongs to the presented admin row, so this reads `me` and never
 * the family. A missing tier on an ADMIN profile is no tier at all.
 */
export function hasTier(me: StaffViewer | undefined, min: StaffTier): boolean {
  if (!canAccessAdmin(me) || !me?.staff_tier) return false;
  return TIER_RANK[me.staff_tier] >= TIER_RANK[min];
}

export function routeMinTier(
  staticData: { minTier?: StaffTier } | undefined,
): StaffTier {
  return staticData?.minTier ?? DEFAULT_MIN_TIER;
}

declare module '@tanstack/react-router' {
  interface StaticDataRouteOption {
    minTier?: StaffTier;
  }
}
